import producer from 'immer';
import {
  FETCH_PROFILE,
  SAVE_PROFILE,
  SET_PROFILE_FIELD_VALID,
  SET_PROFILE_FIELD_VALUE,
  DISMISS_SNACKBAR,
} from './constants';
import {
  handleFetchProfile,
  handleSaveProfile,
  handleSetFieldValue,
  handleSetFieldValid,
  handleDismissSnackbar,
} from './handlers';

export const initialProfile = {
  id: 0,
  name: {
    value: '',
    valid: false,
    validated: false,
  },
  phoneNumber: '',
  email: '',
  alternativeEmail: {
    value: '',
    valid: false,
    validated: false,
  },
  birthDate: {
    value: '',
    valid: false,
    validated: false,
  },
  acceptWhatsapp: {
    value: true,
  },
  acceptSms: {
    value: true,
  },
  hashId: null,
};

export const initialState = {
  loaded: false,
  error: false,
  updatedProfile: initialProfile,
  isSubmitting: false,
};

export const profileReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_PROFILE:
      return handleFetchProfile(state, action);
    case SAVE_PROFILE:
      return handleSaveProfile(state, action);
    case SET_PROFILE_FIELD_VALUE:
      return handleSetFieldValue(state, action);
    case SET_PROFILE_FIELD_VALID:
      return handleSetFieldValid(state, action);
    case DISMISS_SNACKBAR:
      return handleDismissSnackbar(state, action);
    default:
      return state;
  }
};

export default producer(profileReducer);
